import React from 'react';
import PropTypes from 'prop-types'


export const InfoCircle = () => {
        return (
                <svg  xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>
    )
}

export const NavigationArrow = () => {
    return (
      <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.0751166 7.38175C0.122711 7.5045 0.194076 7.61664 0.285117 7.71175L5.28512 12.7117C5.53878 12.9654 5.90849 13.0645 6.255 12.9716C6.6015 12.8788 6.87215 12.6081 6.965 12.2616C7.05784 11.9151 6.95878 11.5454 6.70512 11.2917L3.40512 8.00175L10.9951 8.00174C11.5474 8.00174 11.9951 7.55403 11.9951 7.00174C11.9951 6.44946 11.5474 6.00174 10.9951 6.00174L3.40512 6.00175L6.70512 2.71175C6.89443 2.52398 7.00091 2.26838 7.00091 2.00175C7.00091 1.73511 6.89443 1.47951 6.70512 1.29175C6.51735 1.10243 6.26175 0.995947 5.99512 0.995947C5.72848 0.995947 5.47288 1.10243 5.28512 1.29175L0.285117 6.29175C0.194076 6.38685 0.122711 6.49899 0.0751166 6.62175C-0.024901 6.86521 -0.0249009 7.13828 0.0751166 7.38175Z" fill="#0085B3"/>
      </svg>
    )  
}

export const ExportMail = () => {
 return (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="path-1-inside-1_9_2154" fill="white">
            <rect x="14.5" y="18" width="21" height="15" rx="0.5"/>
        </mask>
        <rect x="14.5" y="18" width="21" height="15" rx="0.5" fill="white"/>
        <rect x="14.5" y="18" width="21" height="15" rx="0.5" stroke="black" strokeWidth="2" mask="url(#path-1-inside-1_9_2154)"/>
        <rect x="14.5" y="18" width="21" height="15" rx="0.5" stroke="black" strokeWidth="2" mask="url(#path-1-inside-1_9_2154)"/>
        <rect x="14.5" y="18" width="21" height="15" rx="0.5" stroke="black" strokeWidth="2" mask="url(#path-1-inside-1_9_2154)"/>
        <rect x="14.5" y="18" width="21" height="15" rx="0.5" stroke="black" strokeWidth="2" mask="url(#path-1-inside-1_9_2154)"/>
        <rect x="14.5" y="18" width="21" height="15" rx="0.5" stroke="black" strokeWidth="2" mask="url(#path-1-inside-1_9_2154)"/>
        <path d="M34.5 19L25.7743 25.7519C25.5531 25.9127 25.2806 26 25 26C24.7194 26 24.4469 25.9127 24.2257 25.7519L15.5 19" stroke="#231F20" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M22.5 25L15.5 32" stroke="#231F20" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M34.5 32L27.5 25" stroke="#231F20" strokeLinecap="round" strokeLinejoin="round"/>
        <rect x="1" y="1" width="48" height="48" rx="24" stroke="black" strokeWidth="2"/>
    </svg>
 )   
}

export const ExportPrint = () => {
    return (
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="path-1-inside-1_9_2144" fill="white">
                <rect x="15" y="20.1035" width="21" height="13.2708" rx="0.5"/>
            </mask>
            <rect x="15" y="20.1035" width="21" height="13.2708" rx="0.5" fill="white"/>
            <rect x="15" y="20.1035" width="21" height="13.2708" rx="0.5" stroke="black" strokeWidth="2" mask="url(#path-1-inside-1_9_2144)"/>
            <rect x="15" y="20.1035" width="21" height="13.2708" rx="0.5" stroke="black" strokeWidth="2" mask="url(#path-1-inside-1_9_2144)"/>
            <rect x="15" y="20.1035" width="21" height="13.2708" rx="0.5" stroke="black" strokeWidth="2" mask="url(#path-1-inside-1_9_2144)"/>
            <rect x="15" y="20.1035" width="21" height="13.2708" rx="0.5" stroke="black" strokeWidth="2" mask="url(#path-1-inside-1_9_2144)"/>
            <rect x="15" y="20.1035" width="21" height="13.2708" rx="0.5" stroke="black" strokeWidth="2" mask="url(#path-1-inside-1_9_2144)"/>
            <mask id="path-2-inside-2_9_2144" fill="white">
                <rect x="19" y="15" width="13" height="6.125" rx="0.5"/>
            </mask>
            <rect x="19" y="15" width="13" height="6.125" rx="0.5" fill="white"/>
            <rect x="19" y="15" width="13" height="6.125" rx="0.5" stroke="black" strokeWidth="2" mask="url(#path-2-inside-2_9_2144)"/>
            <rect x="19" y="15" width="13" height="6.125" rx="0.5" stroke="black" strokeWidth="2" mask="url(#path-2-inside-2_9_2144)"/>
            <rect x="19" y="15" width="13" height="6.125" rx="0.5" stroke="black" strokeWidth="2" mask="url(#path-2-inside-2_9_2144)"/>
            <rect x="19" y="15" width="13" height="6.125" rx="0.5" stroke="black" strokeWidth="2" mask="url(#path-2-inside-2_9_2144)"/>
            <rect x="19" y="15" width="13" height="6.125" rx="0.5" stroke="black" strokeWidth="2" mask="url(#path-2-inside-2_9_2144)"/>
            <mask id="path-3-inside-3_9_2144" fill="white">
                <rect x="19" y="27.25" width="13" height="8.75" rx="0.5"/>
            </mask>
            <rect x="19" y="27.25" width="13" height="8.75" rx="0.5" fill="white"/>
            <rect x="19" y="27.25" width="13" height="8.75" rx="0.5" stroke="black" strokeWidth="2" mask="url(#path-3-inside-3_9_2144)"/>
            <rect x="19" y="27.25" width="13" height="8.75" rx="0.5" stroke="black" strokeWidth="2" mask="url(#path-3-inside-3_9_2144)"/>
            <rect x="19" y="27.25" width="13" height="8.75" rx="0.5" stroke="black" strokeWidth="2" mask="url(#path-3-inside-3_9_2144)"/>
            <rect x="19" y="27.25" width="13" height="8.75" rx="0.5" stroke="black" strokeWidth="2" mask="url(#path-3-inside-3_9_2144)"/>
            <rect x="19" y="27.25" width="13" height="8.75" rx="0.5" stroke="black" strokeWidth="2" mask="url(#path-3-inside-3_9_2144)"/>
            <line x1="18.5" y1="27.7715" x2="32.5" y2="27.7715" stroke="black" strokeLinecap="round"/>
            <line x1="30.5" y1="23.6875" x2="32.5" y2="23.6875" stroke="black" strokeLinecap="round"/>
            <rect x="1" y="1" width="48" height="48" rx="24" stroke="black" strokeWidth="2"/>
    </svg>
    )
}

export const Chevron = () => {
    return (
        <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<           path d="M13 1.83316L11.4725 0.305664L6.5 5.26733L1.5275 0.305664L1.84058e-06 1.83316L6.5 8.33316L13 1.83316Z" fill="currentcolor"/>
        </svg>       
    )
}